export default "__VITE_ASSET__4M0o$6Cp__"